import { emsApi } from '@/api/emsApi';

export async function createDemoIncidents(lang: string): Promise<void> {
  const { response } = await emsApi.POST('/demo/v1/create-incidents', {
    body: { lang },
  });

  if (!response.ok) {
    throw new Error(`Creating demo incidents failed (HTTP ${response.status})`);
  }
}
